<template>
  <v-layout row justify-center>
    <div class="mt-8">
      <v-container>
        <v-form ref="form">
          <div class="font-weight-bold text-center" style="font-size: larger; position: relative;">
            {{ getContractName }}
            <v-flex xs6 class="d-flex align-center" style="position: absolute; right: 50px; top: -17px; font-weight: 400;">
              <v-checkbox v-model="contract.is_visit" label="訪問用" @change="updateContractForVisit"></v-checkbox>
            </v-flex>
          </div>
          <v-container
            class="over-flow-auto grid-list-md"
            style="max-width: 1000px"
          >
            <v-layout wrap style="max-width: 1200px">
              <!-- Counselor Selection -->
              <v-flex xs4>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="contractDateFormated"
                        label="契約日"
                        persistent-hint
                        v-bind="attrs"
                        v-on="on"
                        width="120px"
                        readonly
                    >
                    </v-text-field>
                </template>
                <v-date-picker
                    v-model="contract.contract_date"
                    :day-format="(date) => new Date(date).getDate()"
                    no-title
                ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4 />
              <v-flex xs4>
                <v-select
                  v-model="contract.contract_manager"
                  :rules="rules.contractManager"
                  :item-text="(counselor) => counselor.name"
                  :item-value="(counselor) => counselor.id"
                  :items="counselors"
                  label="契約担当者"
                  :readonly="isLoading"
                  return-object
                />
              </v-flex>

              <!-- Customer Info -->
              <v-flex xs12>
                <h4>基礎情報</h4>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.family_name"
                  label="姓"
                  :readonly="isLoading"
                  required
                  counter="16"
                  :rules="rules.customer.family_name"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.given_name"
                  label="名"
                  :readonly="isLoading"
                  required
                  counter="16"
                  :rules="rules.customer.given_name"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.family_name_kana"
                  label="せい"
                  :readonly="isLoading"
                  counter="16"
                  required
                  :rules="rules.customer.family_name_kana"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.given_name_kana"
                  label="めい"
                  :readonly="isLoading"
                  counter="16"
                  required
                  :rules="rules.customer.given_name_kana"
                />
              </v-flex>
              <v-flex xs8>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="customer.birthday"
                      label="生年月日"
                      :rules="rules.customer.birthday"
                      persistent-hint
                      v-bind="attrs"
                      v-on="on"
                      readonly
                    />
                  </template>
                  <v-date-picker
                    v-model="customer.birthday"
                    :day-format="(birthday) => new Date(birthday).getDate()"
                    no-title
                    :readonly="isLoading"
                  />
                </v-menu>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="customer.age" readonly />
              </v-flex>
              <v-flex xs2>
                <v-select
                  label="血液型"
                  v-model="customer.blood_type"
                  :items="constants.bloodTypes.LIST"
                  required
                  :rules="rules.customer.blood_type"
                />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="customer.email_address"
                  label="メールアドレス"
                  type="text"
                  :rules="rules.customer.email_address"
                  counter="64"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="customer.zip_code"
                  label="〒"
                  type="text"
                  :readonly="isLoading"
                  required
                  counter="8"
                  :rules="rules.customer.zip_code"
                >
                  <template v-slot:append>
                    <v-btn icon small outlined @click="getZip()">
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-select
                  label="本籍"
                  v-model="customer.pref"
                  :readonly="isLoading"
                  :items="prefectures"
                  :rules="rules.customer.pref"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.phone_number"
                  label="携帯電話番号"
                  type="text"
                  :readonly="isLoading"
                  required
                  counter="16"
                  :rules="rules.customer.phone_number"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.phone_number_home"
                  label="自宅電話番号"
                  counter="16"
                  type="text"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="customer.address1"
                  label="市区町村"
                  type="text"
                  :readonly="isLoading"
                  required
                  counter="48"
                  :rules="rules.customer.address1"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="customer.address2"
                  label="住所"
                  type="text"
                  :readonly="isLoading"
                  counter="48"
                  required
                  :rules="rules.customer.address2"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="customer.building_name"
                  label="マンション等"
                  counter="48"
                  type="text"
                  :readonly="isLoading"
                />
              </v-flex>

              <!-- Company -->
              <v-flex xs6>
                <v-text-field
                  v-model="customer.company_name"
                  label="会社名"
                  type="text"
                  counter="32"
                  :rules="rules.customer.company_name"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="customer.company_name_kana"
                  label="会社名ーふりがな"
                  type="text"
                  :rules="rules.customer.company_name_kana"
                  counter="32"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="customer.company_zip_code"
                  label="〒"
                  type="text"
                  :rules="rules.customer.company_zip_code"
                  counter="8"
                  :readonly="isLoading"
                >
                  <template v-slot:append>
                    <v-btn icon small outlined @click="getZipCompany()">
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  v-model="customer.company_address"
                  label="住所"
                  type="text"
                  :rules="rules.customer.company_address"
                  counter="64"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-model="customer.company_tel"
                  label="勤務先電話番号"
                  type="text"
                  :rules="rules.customer.company_tel"
                  counter="16"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-model="customer.industry"
                  label="業種"
                  type="text"
                  :rules="rules.customer.industry"
                  counter="16"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-model="customer.employment_years"
                  label="勤続"
                  type="text"
                  :rules="rules.customer.employment_years"
                  counter="16"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-model="customer.income"
                  label="年収"
                  :rules="rules.customer.income"
                  type="text"
                  counter="16"
                  :readonly="isLoading"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-model="customer.holidays"
                  label="休日"
                  :rules="rules.customer.holidays"
                  type="text"
                  counter="16"
                  :readonly="isLoading"
                />
              </v-flex>

              <!-- Money -->
              <v-flex xs6>
                <h4>お支払い 税込</h4>
              </v-flex>
              <v-flex xs6>
                <h4>残金支払内容</h4>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  :value="formattedServiceFee"
                  label="登録料（税込）"
                  type="text"
                  readonly
                />
                <v-text-field
                  v-model.number="contract.tax"
                  label="分割手数料"
                  type="text"
                  :rules="rules.tax"
                  min="0"
                  max="9999999"
                  step="10000"
                  :readonly="isLoading"
                  @keypress="onlyNumber"
                />
                <v-text-field
                  :value="formattedTotalAmountIncludingTax"
                  label="登録料＋分割手数料"
                  type="text"
                  readonly
                />
                <v-text-field
                  v-model.number="contract.amount_paid_upon_signing_contract"
                  label="契約時内金"
                  :readonly="isLoading"
                  type="text"
                  min="0"
                  :max="contract.total_amount_including_tax"
                  step="10000"
                  @keypress="onlyNumber"
                  :rules="rules.amount_paid_upon_signing_contract"
                />
                <v-text-field
                  :value="formattedRemainingAmount"
                  label="分割支払残金額"
                  type="text"
                  readonly
                />
                <v-text-field
                  label="残金支払内容の合算値"
                  type="text"
                  :value="totalMoneyPaid"
                  readonly
                />
                <h4>次回来社</h4>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="next_arrival_date"
                      label="次回来社日"
                      persistent-hint
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="next_arrival_date = null"
                      readonly
                    />
                  </template>
                  <v-date-picker
                    v-model="next_arrival_date"
                    :day-format="
                      (next_arrival_date) =>
                        new Date(next_arrival_date).getDate()
                    "
                    no-title
                    :readonly="isLoading"
                  />
                </v-menu>
                <v-dialog
                  ref="dialog1"
                  v-model="timePick['nextArrivalTime']"
                  :return-value.sync="next_arrival_time"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="next_arrival_time"
                      label="来社時間"
                      readonly
                      clearable
                      @click:clear="next_arrival_time = null"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="timePick['nextArrivalTime']"
                    v-model="next_arrival_time"
                    full-width
                    scrollable
                    :readonly="isLoading"
                    format="24hr"
                  >
                    <v-btn
                      text
                      color="primary"
                      @click="timePick['nextArrivalTime'] = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveNextArrivalTime">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs1 />

              <!-- Payment -->
              <v-flex xs3>
                <v-select
                  v-model="contract.payment_method"
                  :items="constants.paymentMethodOptions.LIST"
                  label="支払"
                  item-text="label"
                  item-value="value"
                  :rules="rules.paymentMethod"
                  :readonly="isLoading"
                />
                <v-layout
                  align-center
                  v-for="(payment_details1, i) in contract.payment_details1"
                  :key="i"
                >
                  <v-flex xs6>
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDateWithoutY(payment_details1.date)"
                          label="支払日"
                          persistent-hint
                          clearable
                          @click:clear="
                            payment_details1.date = null;
                            payment_details1.amount = null;
                          "
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        />
                      </template>
                      <v-date-picker
                        v-model="payment_details1.date"
                        :day-format="(date) => new Date(date).getDate()"
                        no-title
                        :readonly="isLoading"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-if="payment_details1.date"
                      v-model.number="payment_details1.amount"
                      label="金額"
                      type="text"
                      :rules="rules.number_range"
                      @keypress="onlyNumber"
                      :readonly="isLoading"
                    />
                    <v-text-field v-else disabled defaultValue="" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-text-field disabled defaultValue="" />
                <v-layout
                  align-center
                  v-for="(payment_details2, i) in contract.payment_details2"
                  :key="i"
                >
                  <v-flex xs6>
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDateWithoutY(payment_details2.date)"
                          label="支払日"
                          persistent-hint
                          v-bind="attrs"
                          clearable
                          @click:clear="
                            payment_details2.date = null;
                            payment_details2.amount = null;
                          "
                          v-on="on"
                          readonly
                        />
                      </template>
                      <v-date-picker
                        v-model="payment_details2.date"
                        :day-format="(date) => new Date(date).getDate()"
                        no-title
                        :readonly="isLoading"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-if="payment_details2.date"
                      v-model.number="payment_details2.amount"
                      label="金額"
                      :rules="rules.number_range"
                      type="text"
                      @keypress="onlyNumber"
                      :readonly="isLoading"
                    />
                    <v-text-field v-else disabled defaultValue="" />
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- Proof of Document -->
              <v-flex xs12>
                <h4>身分証明書の確認</h4>
              </v-flex>
              <v-flex xs3>
                <v-select
                  v-model="contract.proof_of_document"
                  :items="constants.proofOfDocuments.LIST"
                  item-text="label"
                  item-value="value"
                  :readonly="isLoading"
                  clearable
                  @click:clear="contract.proof_of_document = null"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  v-if="contract.proof_of_document === 4"
                  v-model="contract.proof_of_document_self_enter"
                  label="自己入力"
                  type="text"
                  :readonly="isLoading"
                  :rules="rules.proof_of_document_self_enter"
                />
                <v-text-field v-else disabled defaultValue="" />
              </v-flex>
              <v-flex xs1 />
              <v-flex xs5>
                <v-text-field
                  v-if="verifyNumberProofofDocumentCondition"
                  v-model="contract.proof_of_document_number"
                  label="証明書類№"
                  type="text"
                  counter="16"
                  :rules="rules.proof_of_document_number"
                  :readonly="isLoading"
                />
                <v-text-field v-else disabled defaultValue="" />
              </v-flex>

              <!-- Time -->
              <v-flex xs12>
                <h4 class="mt-4">役務提供期間（契約期間）</h4>
              </v-flex>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs6>
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="contract.start_date"
                          label="開始日"
                          persistent-hint
                          v-bind="attrs"
                          :rules="rules.contract_start_date"
                          v-on="on"
                          readonly
                        />
                      </template>
                      <v-date-picker
                        v-model="contract.start_date"
                        :day-format="(date) => new Date(date).getDate()"
                        :readonly="isLoading"
                        clearable
                        no-title
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(contract.end_date)"
                          label="終了日"
                          persistent-hint
                          v-bind="attrs"
                          :rules="rules.contract_end_date"
                          v-on="on"
                          readonly
                        />
                      </template>
                      <v-date-picker
                        v-model="contract.end_date"
                        :day-format="(date) => new Date(date).getDate()"
                        no-title
                        :min="contract.start_date"
                        :readonly="isLoading"
                      />
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- Signature -->
              <v-flex xs12>
                <h4>署名</h4>
                <v-container
                  fluid
                  fill-height
                  class="d-flex flex-column align-center justify-center"
                >
                  <canvas
                    ref="canvasRef"
                    :width="600"
                    :height="200"
                    style="border: 1px solid #000; margin-bottom: 4px"
                  ></canvas>
                  <button
                    type="button"
                    class="clear-btn"
                    :disabled="isLoading"
                    @click="clearSignature"
                  >
                    リセット
                  </button>
                </v-container>
              </v-flex>
            </v-layout>

            <!-- Submit -->
            <v-layout>
              <v-flex xs11 />
              <v-flex xs1>
                <v-btn color="info" :loading="isLoading" @click="save">
                  確認する
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-container>
    </div>
    <!-- Alert -->
    <v-dialog width="460" v-model="dialog" persistent>
      <template>
        <v-card title="Dialog">
          <v-card-text class="pt-4 text-center">
            分割支払残金額と残金支払い内容の合算値が一致していません。
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn class="info" @click="handleShowAlert">閉じる </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import SignaturePad from "signature_pad";
import moment from "moment";
import constants from "@/consts/constants.js";

export default {
  name: "ContractInput",
  title: "契約書入力",
  data: function () {
    const bloodTypes = CUSTOMER.BLOOD_TYPE;
    const proofOfDocuments = CUSTOMER.PROOF_OF_DOCUMENTS;
    const paymentMethodOptions = CUSTOMER.PAYMENT_METHOD_OPTIONS;
    const education = CUSTOMER.FINAL_EDUCATION;

    const payment_details_default = {
      date: null,
      amount: null,
    };
    const payment_details_init1 = Array.from({ length: 6 }, () => ({
      ...payment_details_default,
    }));
    const payment_details_init2 = Array.from({ length: 6 }, () => ({
      ...payment_details_default,
    }));

    return {
      rules: {
        customer: {
          family_name: [
            (v) => !!v || "氏名を入れてください",
            (v) => v.length <= 16 || "氏名は16文字までです",
          ],
          given_name: [
            (v) => !!v || "氏名を入れてください",
            (v) => v.length <= 16 || "氏名は16文字までです",
          ],
          family_name_kana: [
            (v) => !!v || "氏名ーフリガナを入れてください",
            (v) => v.length <= 16 || "氏名ーフリガナは16文字までです",
            (v) => /^[ぁ-ゞ\s]*$/.test(v) || "ひらがなで入力してください",
          ],
          given_name_kana: [
            (v) => !!v || "氏名ーフリガナを入れてください",
            (v) => v.length <= 16 || "氏名ーフリガナは16文字までです",
            (v) => /^[ぁ-ゞ\s]*$/.test(v) || "ひらがなで入力してください",
          ],
          zip_code: [
            (v) => !!v || "郵便番号を入力してください",
            (v) => v.length <= 8 || "郵便番号は8文字までです",
          ],
          address1: [
            (v) => !!v || "市区町村を入れてください",
            (v) => v.length <= 48 || "市区町村は48文字までです",
          ],
          address2: [
            (v) => !!v || "住所を入れてください",
            (v) => v.length <= 48 || "住所は48文字までです",
          ],
          phone_number: [
            (v) => !!v || "携帯電話番号を入れてください",
            (v) => v.length <= 16 || "携帯電話番号は16文字までです",
          ],
          phone_number_home: [
            (v) => v.length <= 16 || "自宅電話番号は16文字までです",
          ],
          email_address: [
            (v) =>
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
              "正しいメールアドレスを入力してください",
            (v) => v.length <= 64 || "メールアドレスは64文字までです",
          ],
          birthday: [(v) => !!v || "生年月日を選択てください"],
          blood_type: [(v) => !!v || "血液型を選択してください"],
          pref: [(v) => !!v || "本籍を入れてください"],
          company_name: [(v) => v.length <= 32 || "会社名は32文字までです"],
          company_name_kana: [
            (v) => v.length <= 32 || "会社名ーふりがなは32文字までです",
            (v) => /^[ぁ-ゞー\s]*$/.test(v) || "ひらがなで入力してください",
          ],
          company_zip_code: [(v) => v.length <= 8 || "郵便番号は8文字までです"],
          company_address: [(v) => v.length <= 64 || "住所は64文字までです"],
          company_tel: [(v) => v.length <= 16 || "電話番号は16文字までです"],
          industry: [(v) => v.length <= 16 || "業種は16文字までです"],
          employment_years: [(v) => v.length <= 16 || "勤続は16文字までです"],
          income: [(v) => v.length <= 16 || "年収は16文字までです"],
          holidays: [(v) => v.length <= 16 || "休日は16文字までです"],
        },
        contractManager: [(v) => !!v || "契約担当者を選択してください"],
        paymentMethod: [(v) => !!v || "支払方法を選択してください"],
        proof_of_document: [(v) => !!v || "身分証明書を選択してください"],
        tax: [
          (v) =>
            (v !== undefined && v !== "" && v !== null) ||
            "分割手数料を入れてください",
          (v) => v <= 9999999 || "0〜9999999までの数値を入力してください",
          (v) => v >= 0 || "0〜9999999までの数値を入力してください",
        ],
        amount_paid_upon_signing_contract: [
          (v) =>
            (v !== undefined && v !== "" && v !== null) ||
            "契約時内金を入れてください",
          (v) =>
            v <= this.contract.total_amount_including_tax ||
            `0~${this.contract.total_amount_including_tax}までの数値を入力してください`,
          (v) => v >= 0 || "0〜9999999までの数値を入力してください",
        ],
        proof_of_document_self_enter: [
          (v) => !!v || "他を入れてください",
          (v) => (v || "").length <= 8 || "他は8文字までです",
        ],
        proof_of_document_number: [
          (v) => (v || "").length <= 16 || "証明書類Noは16文字までです",
          (v) => !!v || "証明書類Noを入れてください",
        ],
        contract_start_date: [(v) => !!v || "開始日を選択してください"],
        contract_end_date: [(v) => !!v || "終了日を選択してください"],
        number_range: [(v) => v <= 9999999, (v) => v >= 0, (v) => !!v],
      },

      customer: {
        id: null,
        full_name: "",
        full_name_kana: "",
        family_name: "",
        given_name: "",
        family_name_kana: "",
        given_name_kana: "",
        gender: null,
        birthday: null,
        age: null,
        blood_type: null,
        phone_number: "",
        phone_number_home: "",
        email_address: "",
        zip_code: "",
        pref: 0,
        address1: "",
        address2: "",
        building_name: "",
        company_name: "",
        company_name_kana: "",
        company_zip_code: "",
        company_address: "",
        company_tel: "",
        industry: "",
        employment_years: "",
        income: "",
        holidays: "",
        shop_id: ""
      },

      contract: {
        contract_manager: null,
        service_fee: 0,
        tax: 0,
        total_amount_including_tax: 0,
        amount_paid_upon_signing_contract: 0,
        remaining_amount: 0,
        payment_method: null,
        payment_additional: null,
        payment_details1: payment_details_init1,
        payment_details2: payment_details_init2,
        proof_of_document: null,
        proof_of_document_self_enter: "",
        proof_of_document_number: "",

        start_date: null,
        end_date: null,
        contract_date: moment(new Date(this.$store.state.contract_date)).format("YYYY-MM-DD"),
        is_visit: false
      },
      next_arrival_date: null,
      next_arrival_time: null,
      timePick: [],

      signaturePad: null,

      course: {},
      counselors: [],
      prefectures: [],

      isLoading: false,
      isEditing: false,

      dialog: false,

      constants: {
        bloodTypes,
        proofOfDocuments,
        paymentMethodOptions,
        payment_details_default,
        education,
      },
      payment_details_init1,
      payment_details_init2,
      oldContract: {}
    };
  },
  watch: {
    "contract.tax": function (newVal) {
      if (this.contract.tax == null) return;
      if (newVal < 0) this.contract.tax = 0;

      this.contract.total_amount_including_tax =
        this.contract.service_fee + Number(this.contract.tax);

      this.contract.remaining_amount =
        this.contract.total_amount_including_tax -
        this.contract.amount_paid_upon_signing_contract;
    },
    "contract.amount_paid_upon_signing_contract": function (newVal) {
      if (this.contract.amount_paid_upon_signing_contract == null) return;
      if (newVal < 0) this.contract.amount_paid_upon_signing_contract = 0;
      this.contract.remaining_amount =
        this.contract.total_amount_including_tax -
        this.contract.amount_paid_upon_signing_contract;
    },
    "customer.birthday": function (newVal) {
      this.customer.age = this.calculateAge(newVal) + " 歳";
    },
    "contract.start_date": function (newVal) {
      if (!newVal) return null
      let endDate = new Date(newVal);
      endDate.setFullYear(endDate.getFullYear() + 1);
      endDate.setDate(endDate.getDate() - 1);
      this.contract.end_date = this.formatDate(endDate);
    },
  },
  computed: {
    formattedServiceFee() {
      return this.formatNumber(this.contract.service_fee);
    },
    formattedTotalAmountIncludingTax() {
      return this.formatNumber(this.contract.total_amount_including_tax);
    },
    formattedRemainingAmount() {
      return this.formatNumber(this.contract.remaining_amount);
    },
    contractDate() {
      const date = new Date(this.$store.state.contract_date);
      return `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日`;
    },
    getContractName() {
      return this.course.name
        ? this.course.name + " - " + "契約書入力"
        : "契約書入力";
    },
    totalMoneyPaid() {
      if (this.contract.is_visit) return null;
      const total1 = this.contract.payment_details1.reduce(
        (acc, cur) => Number(acc) + cur.amount,
        0
      );
      const total2 = this.contract.payment_details2.reduce(
        (acc, cur) => Number(acc) + cur.amount,
        0
      );

      return this.formatNumber(total1 + total2);
    },
    verifyNumberProofofDocumentCondition() {
      return this.contract.proof_of_document === 1;
    },
    contractDateFormated() {
      return this.contract.contract_date ? moment(new Date(this.contract.contract_date)).format("YYYY/MM/DD") : '';
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "customer_contract_review" && this.canAlter()) {
      const answer = window.confirm(
        "入力した情報が消去される可能性があります。続行してもよろしいですか？"
      );
      if (answer) {
        next();
        this.preventBackNavigation();
        this.$store.dispatch("updateContractTempData", {});
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  async created() {
    this.userId = this.$route.params.userId;
    this.courseId = this.$route.params.courseId;
    this.id = this.$route.query.contractId;

    this.isEditing = this.id ? true : false;
    if (this.canAlter() === false && this.isEditing) {
      this.$router.push({ name: "customer_list" });
    }
    if (this.isEditing) {
      await this.getEditInitialData();
    } else {
      await this.getInputInitialData();
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    const canvas = this.$refs.canvasRef;
    if (canvas)
      this.signaturePad = new SignaturePad(canvas, {
        minWidth: 6,
      });
  },
  methods: {
    handleBeforeUnload(event) {
      const message =
        "入力した情報が消去される可能性があります。続行してもよろしいですか？";
      event.preventDefault();
      event.returnValue = message;
      return message;
    },
    preventBackNavigation() {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", () => {
        window.history.pushState(null, "", window.location.href);
      });
    },
    async getInputInitialData() {
      try {
        const [userRes, courseRes, prefecturesRes] = await Promise.all([
          this.$axios.get(`/api/v1/course-contract/user-data/${this.userId}`),
          this.$axios.get(
            `/api/v1/course-contract/course-detail/${this.courseId}`
          ),
          this.$axios.get(`/api/v1/course-contract/prefectures`),
        ]);
        this.course = courseRes.data;
        this.prefectures = prefecturesRes.data;
        this.importCustomerData(userRes.data);
        this.initCourseMoney();
        const counselorRes = await this.$axios.get(
          `/api/v1/user/counselors/?shop_id=${userRes.data.shop_id}`
        );
        this.counselors = counselorRes.data.counselors;
        this.contract.start_date = this.formatDate(
          this.$store.state.contract_start_date
        );
        let endDate = new Date(this.$store.state.contract_start_date);
        endDate.setFullYear(endDate.getFullYear() + 1);
        endDate.setDate(endDate.getDate() - 1);
        this.contract.end_date = this.formatDate(endDate);
        if (this.$store.state.contract_temp_data?.customerData?.id) {
          const tempData = this.$store.state.contract_temp_data;
          this.contract = tempData.contract;
          this.next_arrival_date = tempData.next_arrival_date;
          this.next_arrival_time = tempData.next_arrival_time;
          this.customer = tempData.customerData;
          this.signaturePad.fromDataURL(tempData.signature, { ratio: 1, width: 600, height: 200});
          this.$store.dispatch("updateContractTempData", {});
        }
        this.oldContract = this.contract
        if (this.contract.is_visit) {
          this.updateContractForVisit()
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getEditInitialData() {
      try {
        const [contractRes, prefecturesRes] = await Promise.all([
          this.$axios.get(`/api/v1/course-contract/${this.id}`),
          this.$axios.get(`/api/v1/course-contract/prefectures`),
        ]);
        this.prefectures = prefecturesRes.data;
        const parsedJSON = JSON.parse(contractRes.data.payment_json);
        const data = parsedJSON.contract
          ? JSON.parse(contractRes.data.payment_json)
          : {
              contract: JSON.parse(contractRes.data.payment_json),
            };
        if (data.customer) {
          this.customer = {...data.customer, email_address: data.customer.email_address.replace(/[\t\r\n]/g, '').trim()};
        } else {
          this.customer.id = contractRes.data.customer_id;
        }
        let shopId = data.contract.contract_manager ? data.contract.contract_manager.shop_id : (this.customer.shop_id || null)
        const counselorRes = await this.$axios.get(
          `/api/v1/user/counselors/?shop_id=${shopId}`
        );
        this.counselors = counselorRes.data.counselors;
        this.contract = {...data.contract, contract_date: data.contract.contract_date || contractRes.data.contract_date};
        this.next_arrival_date = data.next_arrival_date;
        this.next_arrival_time = data.next_arrival_time;
        let newSignature = data.signature;
        this.$store.dispatch(
          "updateContractDate",
          contractRes.data.contract_date ? moment(new Date(contractRes.data.contract_date)).format("YYYY/MM/DD") : null
        );
        this.contract.contract_date = this.formatDate(contractRes.data.contract_date);
        this.contract.start_date = this.formatDate(contractRes.data.start_date);
        this.contract.end_date = this.formatDate(contractRes.data.end_date);
        if (this.$store.state.contract_start_date) {
          this.contract.start_date = this.formatDate(
            this.$store.state.contract_start_date
          );
          this.contract.end_date = this.formatDate(
            this.$store.state.contract_end_date
          );
          if (this.$store.state.contract_temp_data?.customerData?.id) {
            const tempData = this.$store.state.contract_temp_data;
            this.contract = tempData.contract;
            this.next_arrival_date = tempData.next_arrival_date;
            this.next_arrival_time = tempData.next_arrival_time;
            this.customer = tempData.customerData;
            // new signature pad
            newSignature = tempData.signature;
            this.$store.dispatch("updateContractTempData", {});
            this.$store.dispatch("updateContractStartDate", "");
            this.$store.dispatch("updateContractEndDate", "");
          }
        }
        this.oldContract = this.contract
        if (this.contract.is_visit) {
          this.updateContractForVisit()
        }
        this.signaturePad.fromDataURL(newSignature, { ratio: 1, width: 600, height: 200});
      } catch (error) {
        console.log(error);
      }
    },
    canAlter() {
      const self = this.$store.state.user;
      if (self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
      if (self.privilege & ACCOUNT.PRIVILEGE.VAL.REQUEST_MOD_COURSE)
        return true;
      return false;
    },
    importCustomerData(_customer) {
      this.customer = {
        id: _customer.id,
        family_name: _customer.family_name,
        given_name:  _customer.given_name,
        family_name_kana: _customer.family_name_kana,
        given_name_kana: _customer.given_name_kana,
        gender: _customer.gender,
        birthday: new Date(_customer.birthday).toISOString().substr(0, 10),
        age: `${this.calculateAge(_customer.birthday)} 歳`,
        blood_type: _customer.blood_type,
        phone_number: _customer.phone_number,
        phone_number_home: _customer.phone_number_home,
        email_address: _customer.email_address.replace(/[\t\r\n]/g, '').trim(),
        zip_code: _customer.zip,
        pref: _customer.pref,
        company_name_kana: _customer.company_name_kana || "",
        address1: _customer.address1,
        address2: _customer.address2,
        building_name: _customer.building_name,
        company_name: _customer.company_name,
        holidays: _customer.holidays,
        company_zip_code: _customer.company_zip,
        company_address: _customer.company_address,
        company_tel: _customer.company_tel,
        industry: _customer.industry,
        employment_years: _customer.employment_years,
        income: _customer.income,
        shop_id: _customer.shop_id
      };
    },
    initCourseMoney() {
      let fee = "";
      switch (parseInt(this.courseId)) {
        case constants.TYPE_COURSE.M_PLATIUM: fee = constants.COURSE_FEE.M_PLATIUM; break;
        case constants.TYPE_COURSE.M_GOLD: fee = constants.COURSE_FEE.M_GOLD; break;
        case constants.TYPE_COURSE.PLATIUM: fee = constants.COURSE_FEE.PLATIUM; break;
        case constants.TYPE_COURSE.GOLD: fee = constants.COURSE_FEE.GOLD; break;
        default: 
          fee = constants.COURSE_FEE.M_GOLD;
      }
      this.contract.service_fee = fee;
      this.contract.tax = 0;
      this.contract.total_amount_including_tax = fee;
      this.contract.amount_paid_upon_signing_contract = 0;
      this.contract.remaining_amount = fee;
    },
    async getZip() {
      const zip = this.customer.zip_code.replace(/[^\d]+/g, "");
      try {
        await this.$axios
          .get("/api/v1/postcode", {
            params: { zip },
          })
          .then((response) => {
            const addressData = response.data;
            this.customer.pref = addressData.prefecture_id;
            this.customer.address1 = addressData.address1;
            this.customer.address2 = addressData.address2;
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getZipCompany() {
      const zip = this.customer.company_zip_code.replace(/[^\d]+/g, "");
      await this.$axios
        .get("/api/v1/postcode", {
          params: { zip },
        })
        .then((response) => {
          const addressData = response.data;
          this.customer.company_address =
            addressData.address1 + addressData.address2;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    calculateAge(birthday) {
      if (!birthday) return;
      const today = new Date();
      const birthDate = new Date(birthday);
      let age = today.getFullYear() - birthDate.getFullYear();
      const isBirthdayPassed =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() >= birthDate.getDate());
      if (!isBirthdayPassed) age--;
      return age;
    },
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDateWithoutY(date) {
      if (!date) return "";
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${month}/${day}`;
    },
    onlyNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    formatNumber(value) {
      if (value === null) return null;
      if (value === undefined || value < 0) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    saveNextArrivalTime() {
      this.$refs.dialog1.save(this.next_arrival_time);
    },
    clearSignature() {
      if (this.signaturePad) {
        this.signaturePad.clear();
      }
    },
    handleShowAlert() {
      this.dialog = !this.dialog;
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (
          this.totalMoneyPaid !==
          this.formatNumber(this.contract.remaining_amount) && !this.contract.is_visit
        ) {
          this.handleShowAlert();
          return;
        }

        try {
          this.isLoading = true;
          this.signaturePad.off();
          this.$store.dispatch("updateContractTempData", {
            contract: this.contract,
            next_arrival_date: this.next_arrival_date,
            next_arrival_time: this.next_arrival_time,
            customerData: this.customer,
            signature: this.signaturePad.toDataURL()
          });
          this.$store.dispatch(
            "updateContractStartDate",
            this.contract.start_date
          );
          this.$store.dispatch("updateContractDate", this.contract.contract_date ? moment(new Date(this.contract.contract_date)).format("YYYY/MM/DD") : this.contract.contract_date);
          this.$store.dispatch("updateContractEndDate", this.contract.end_date);
          const signature = this.signaturePad.toDataURL();

          const postData = {
            contract: this.contract,
            next_arrival_date: this.next_arrival_date || null,
            next_arrival_time: this.next_arrival_time || null,
            course_id: this.courseId,
            customer_id: this.customer.id,
            signature: signature,
            contract_date: this.$store.state.contract_date,
            customer: this.customer,
          };
          const res = await this.$axios.post(
            `/api/v1/course-contract`,
            postData
          );
          this.$router.push({
            name: "customer_contract_review",
            params: {
              userId: this.userId,
              tempContractId: res.data.temp_contract_id,
            },
            query: {
              contractId: this.id,
            },
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    updateContractForVisit () {
      this.rules.paymentMethod = this.contract.is_visit ? [] : [(v) => !!v || "支払方法を選択してください"]
      this.rules.contractManager = this.contract.is_visit ? [] : [(v) => !!v || "契約担当者を選択してください"]
      this.rules.contract_start_date = this.contract.is_visit ? [] : [(v) => !!v || "開始日を選択してください"]
      this.rules.contract_end_date = this.contract.is_visit ? [] : [(v) => !!v || "終了日を選択してください"]
      this.rules.tax = this.contract.is_visit ? [] : [
          (v) =>
            (v !== undefined && v !== "" && v !== null) ||
            "分割手数料を入れてください",
          (v) => v <= 9999999 || "0〜9999999までの数値を入力してください",
          (v) => v >= 0 || "0〜9999999までの数値を入力してください",
        ]
      this.rules.amount_paid_upon_signing_contract = this.contract.is_visit ? [] : [
          (v) =>
            (v !== undefined && v !== "" && v !== null) ||
            "契約時内金を入れてください",
          (v) =>
            v <= this.contract.total_amount_including_tax ||
            `0~${this.contract.total_amount_including_tax}までの数値を入力してください`,
          (v) => v >= 0 || "0〜9999999までの数値を入力してください",
        ]
      if (this.contract.is_visit) {
        this.contract = this.defaultContractForVisit()
        this.contract.is_visit = true
      } else {
        this.contract = this.oldContract
        this.contract.is_visit = false
      }

      if (!this.contract.is_visit) {
        this.initCourseMoney()
        this.contract.contract_date = this.$store.state.contract_date ? moment(new Date(this.$store.state.contract_date)).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
      } else {
        this.contract.contract_date = moment().format("YYYY-MM-DD")
      }
    },
    defaultContractForVisit() {
      return {
        contract_manager: null,
        service_fee: null,
        tax: null,
        total_amount_including_tax: null,
        amount_paid_upon_signing_contract: null,
        remaining_amount: null,
        payment_method: null,
        payment_additional: null,
        payment_details1: this.payment_details_init1,
        payment_details2: this.payment_details_init2,
        proof_of_document: null,
        proof_of_document_self_enter: "",
        proof_of_document_number: "",
        start_date: null,
        end_date: null,
        contract_date: null,
      };
    }
  },
};
</script>

<style scoped>
.container.grid-list-md .layout .flex {
  padding: 4px 8px;
}

.container.grid-list-md > .layout {
  padding: 32px;
}

.clear-btn {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  justify-content: center;
  outline: 0;
  position: relative;
  text-decoration: none;
  text-indent: 0.0892857143em;
  text-transform: uppercase;
  transition-duration: 0.28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  background-color: transparent;
  color: #000;
  cursor: pointer;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
  text-align: center;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transition: all 0.3s;
  margin-top: 8px;
}
.clear-btn:hover {
  background-color: #f5f5f5;
}
</style>
